import * as React from "react";
const SvgAddRemove = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M22 6.9375V13.7188H29C30.0625 13.7188 31 14.627 31 15.6562C31 16.7461 30.0625 17.5938 29 17.5938H22V24.375C22 25.4648 21.0625 26.3125 20 26.3125C18.875 26.3125 18 25.4648 18 24.375V17.5938H11C9.875 17.5938 9 16.7461 9 15.6562C9 14.627 9.875 13.7188 11 13.7188H18V6.9375C18 5.9082 18.875 5 20 5C21.0625 5 22 5.9082 22 6.9375ZM8 33.0625C8 32.0332 8.875 31.125 10 31.125H30C31.0625 31.125 32 32.0332 32 33.0625C32 34.1523 31.0625 35 30 35H10C8.875 35 8 34.1523 8 33.0625Z" }));
export default SvgAddRemove;
